import React from 'react';
import { Select as AntdSelect } from 'antd';

export const Select = (props) => {
    return (
        <AntdSelect
            showSearch
            filterOption={(input, option) =>
                option?.label?.toString().toLowerCase().includes(input.toLowerCase()) ?? false
            }
            {...props}
        />
    );
};

// Add Option back for usage like in Ant Design
Select.Option = AntdSelect.Option;
